import request from '@/sheep/request';

// 共愿小组
export interface Group {
	id?: string
	name: string
	description?: string
	icon?: string
	privacy: number // 0-私密, 1-公开, 2-仅邀请
	maxMembers: number
	memberCount?: number
}

// 创建小组
export const createGroup = async (data: Partial<Group>) => {
	return request({
		url: '/wish/groups/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '创建成功'
		},
	});
}

// 获取小组详情
export const getGroupDetail = async (id: string) => {
	return request({
		url: '/wish/groups/get',
		method: 'GET',
		params: { id }
	});
}

// 获取小组列表
export const getGroupList = async (params?: any) => {
	return request({
		url: '/wish/groups/page',
		method: 'GET',
		params
	});
}

// 获取我的创建小组列表
export const getMyCreatedGroups = async (params?: any) => {
	return request({
		url: '/wish/groups/owner/page',
		method: 'GET',
		params,
		custom: {
			auth: true,
		},
	});
}

// 获取我的加入小组列表
export const getMyJoinedGroups = async (params?: any) => {
	return request({
		url: '/wish/groups/joined/page',
		method: 'GET',
		params,
		custom: {
			auth: true,
		},
	});
}

// 更新小组信息
export const updateGroup = async (data: Partial<Group>) => {
	return request({
		url: '/wish/groups/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 解散小组
export const deleteGroup = async (id: number) => {
	return request({
		url: '/wish/groups/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '已解散'
		},
	});
}

// 加入小组
export const joinGroup = async (groupId: string, inviteCode?: string) => {
	const params: any = { groupId }
	if (inviteCode) {
		params.inviteCode = inviteCode
	}
	return request({
		url: '/wish/groups/join',
		method: 'GET',
		params,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '加入成功'
		},
	});
}


// 加入小组 - 邀请码验证
export const validateInviteCode = async (params: any) => {
	return request({
		url: '/wish/groups/invite-validate',
		method: 'GET',
		params,
		custom: {
			auth: true,
		}
	});
}

// 退出小组
export const quitGroup = async (groupId: number) => {
	return request({
		url: '/wish/groups/quit',
		method: 'GET',
		params: { groupId },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '已退出'
		},
	});
}

// 获取我的小组列表
export const getMyGroups = async () => {
	return request({
		url: '/wish/groups/my-list',
		method: 'GET',
		custom: {
			auth: true,
		},
	});
}

// 获取小组成员列表
export const getGroupsMemberPage = async (params?: any) => {
	return request({
		url: '/wish/groups/member/page',
		method: 'GET',
		params
	});
}

// 禁言
export const mutedGroupMember = async (groupId: number, userId: number) => {
	return request({
		url: '/wish/groups/members/muted',
		method: 'GET',
		params: { groupId, userId },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '禁言成功'
		},
	});
}

// 解除禁言
export const unMutedGroupMember = async (groupId: number, userId: number) => {
	return request({
		url: '/wish/groups/members/un-muted',
		method: 'GET',
		params: { groupId, userId },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '解除禁言成功'
		},
	});
}

// 退出小组
export const dissolveGroups = async (groupId: string) => {
	return request({
		url: '/wish/groups/dissolve',
		method: 'GET',
		params: { groupId },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '已解散小组'
		},
	});
}